// extracted by mini-css-extract-plugin
export default {"root":"ProductSetup-root_VZdmT","container":"ProductSetup-container_GavqS","label":"ProductSetup-label_PmjnO"};